import { Loading } from "element-ui";
import { confirmIdentityApis } from "../../api";
import store from "../../store";

const confirmIdentity = {
  path: "confirmIdentity",
  component: resolve => require(["../../pages/confirmIdentity"], resolve),
  beforeEnter: (to, from, next) => {
    let loading = Loading.service();
    confirmIdentityApis
      .getUserNavBarImg()
      .then(response => {
        if (response.data) {
          store.dispatch("setUserNavBarImg", response.data || "");
        }
        next();
      })
      .finally(() => {
        loading.close();
      });
  }
};

export default confirmIdentity;



// WEBPACK FOOTER //
// ./src/router/confirmIdentity/index.js